import type {Vector2Like} from "@cm/math"

export const TRACE_TILED_TEXTURES = false
export const ALLOW_TILE_DEBUG_RENDER_MODES = false

// this determines the encoding for page requests and must match the encoding/decoding in the shader !
export const TEXTURE_TILES_MAX_IDS = 4096 // we only reserve 12 bits for tiledTextureId in the encoding
export const TEXTURE_TILES_MAX_MIP_LEVELS = 16 // we reserve 4 bits for mipLevel in the encoding
export const TEXTURE_TILES_MAX_TILES_X = 256 // we reserve 8 bits for tileX in the encoding
export const TEXTURE_TILES_MAX_TILES_Y = 256 // we reserve 8 bits for tileY in the encoding

export const TEXTURE_TILE_SIZE = 128 // in pixels
export const TEXTURE_TILE_MARGIN = 2 // in pixels; mip0 needs 2× the mip1 margin so UV content ranges align exactly

export const ATLAS_FORMATS = ["rgba8", "r8"] as const
export type AtlasFormat = (typeof ATLAS_FORMATS)[number]
export const TILE_LOCK_FRAMES = 4 // frames a tile stays locked after markTileAsUsed(); if all tiles are locked, the atlas expands

export const USE_DEBUG_TILE_IMAGE = false

// Mip debug color palette — shared between shader and the debug tile image generator in the browser package.
// Matches mipDebugColor in texture-virtual-three-node.ts.
export const MIP_DEBUG_COLORS: [number, number, number][] = [
    [255, 255, 255], // 0 white
    [255, 255, 0], // 1 yellow
    [0, 255, 255], // 2 cyan
    [255, 0, 255], // 3 magenta
    [0, 255, 0], // 4 green
    [255, 0, 0], // 5 red
    [0, 0, 255], // 6 blue
]

// Re-export for consumers that only need the tile size shape, without importing Vector2Like separately.
export type {Vector2Like}
